export default class BasePopupFormBuilder {
    #action;
    #title;
    #description;
    #formName;
    #submitText;

    /**
     *
     * @param {string} formAction
     * @param {string} title
     * @param {string} description
     * @param {string} formName
     * @param {string} submitText
     */
    constructor(
        {
            title,
            description,
            formAction,
            formName,
            submitText,
        }
    ) {
        this.#action = formAction;
        this.#title = title;
        this.#description = description;
        this.#formName = formName;
        this.#submitText = submitText;
    }

    /**
     *
     * @param {HTMLElement} container
     */
    build(
        {
            container,
        }
    ) {
        /** @type {HTMLElement|null} */
        const modalHeader = container.querySelector('.modal-form-header strong');
        if (modalHeader) {
            modalHeader.textContent = this.#title;
        }


        /** @type {HTMLElement|null} */
        const modalDescription = container.querySelector('.modal-text');
        if (modalDescription) {
            modalDescription.innerHTML = this.#description;
        }

        const form = container.querySelector('form');

        /** @type {HTMLInputElement|null} */
        const submitButton = form.querySelector('input[type="submit"]')
        if (submitButton) {
            submitButton.value = this.#submitText;
        }

        // Preparation
        container.classList.remove('saas-popup');
        form.querySelectorAll('input[name=name-form], input[name=form-redirect]').forEach(e => e.remove())

        form.action = this.#action
        form.dataset.formName = this.#formName;


        // Show modal popup
        container.classList.add('showModal')
    }

}
